import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import { Button } from '@airtm/airtm-ui';
import { LOCAL_STORAGE, PLAYSTORE_LINK } from '@constants';
import playstoreEs from 'assets/images/logo-playstore-es.svg';
import playstoreEn from 'assets/images/logo-playstore-en.svg';
import playstorePT from 'assets/images/logo-playstore-pt.svg';
import getBrowserUtmData from 'utils/getBrowserUtmData';

// new logos on https://play.google.com/intl/es-419/badges/
const playstoreLogoSrc = {
  es: playstoreEs,
  en: playstoreEn,
  pt: playstorePT,
};

const PlaystoreButton = function ({ className }) {
  const { i18n } = useTranslation();
  const classes = cx('p-0', className);

  const link = useMemo(() => {
    const referrer = localStorage.getItem(LOCAL_STORAGE.ANDROID_REFERRER);
    const utmData = getBrowserUtmData();

    const params = new URLSearchParams({ hl: i18n.language });

    // @SONAR_STOP@
    if (utmData && Object.keys(utmData).length > 0) {
      Object.entries(utmData).forEach(([key, value]) => {
        if (value) params.append(key, value);
      });
    }
    // @SONAR_START@

    if (referrer) {
      params.append('referrer', encodeURIComponent(referrer));
    }

    return `${PLAYSTORE_LINK}&${params.toString()}`;
  }, [i18n.language]);

  return (
    <Button
      component="a"
      variant="tertiary"
      className={classes}
      target="_blank"
      rel="noopener noreferrer"
      href={link}
      data-testid="google-play-login"
    >
      <img src={playstoreLogoSrc[i18n.language]} className="u-h50" alt="logo playstore" />
    </Button>
  );
};

PlaystoreButton.propTypes = {
  className: PropTypes.string,
};

PlaystoreButton.defaultProps = {
  className: null,
};

export default PlaystoreButton;
